<template>
	<v-sheet color="transparent">
		<v-row>
			<v-col>
				<h1 class="cn-font text-center mb-5">	
					So funktioniert CHECK IT NOW
				</h1>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="4">
				<InfographicTile 
				title="Messen" 
				text="Erfassung der aktuellen digitalen Reife Ihrer Gesundheitseinrichtung" 
				image="icon2.svg">
				</InfographicTile>
			</v-col>
			<v-col cols="12" md="4">
				<InfographicTile 
				title="Bewerten" 
				text="Abgleich der Ergebnisse zu definierten Zielsetzungen und Benchmarks" 
				image="icon3.svg">
				</InfographicTile>
				
			</v-col>
			<v-col cols="12" md="4">
				<InfographicTile 
				title="Gestalten" 
				text="Zielgerichte Regulierung und Förderung auf nationaler und regionaler Ebene" 
				image="icon1.svg">
				</InfographicTile>
				
			</v-col>
		</v-row>
		<v-row>	
			<v-col>

			<h1 class="cn-font primary--text mb-5">Prozess</h1>	
				<ProcessStep 
					number="1"
					side="right"
					title="Ist-Analyse"
					text="Erfassung des digitalen Reifegrades"
				></ProcessStep>
				<ProcessStep 
					number="2"
					side="left"
					title="Priorisierung"
					text="Abgleich zu definierten Zielsetzungen und internationalen Benchmarks"
				></ProcessStep>
				<ProcessStep 
					number="3"
					side="right"
					title="Umsetzung"
					text="Zielgerichtete Regulierungs- und Investitionsentscheidungen"
				></ProcessStep>
				<ProcessStep 
					number="4"
					side="left"
					title="Evaluation"
					text=""
				></ProcessStep>			
			</v-col>
		</v-row>	
		<p>
			<BackButton></BackButton>
		</p>	
	</v-sheet>
</template>

<script>
	import BackButton from "@/components/elements/BackButton"
	import ProcessStep from "@/components/elements/ProcessStep"
	import InfographicTile from "@/components/elements/InfographicTile"
	export default {
		name: "HowItWorks",
		components: {
			BackButton, 
			ProcessStep,
			InfographicTile,
		},
	}
</script>